import axios from 'axios';
import store from '@/store';
import Vue from 'vue';
import router from '@/router';

const API_URL = process.env.VUE_APP_LEGACY_SITE;

const httpClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    crossDomain: false,
});

const authInterceptor = (config) => {
    const authToken = localStorage.getItem('ss_access_token');
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
};

httpClient.interceptors.request.use(authInterceptor);

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(callback) {
    refreshSubscribers.push(callback);
}

function onTokenRefreshed(newToken) {
    refreshSubscribers.forEach(callback => callback(newToken));
    refreshSubscribers = [];
}


httpClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        const route = originalRequest.url.replace(originalRequest.baseURL, '');

        if (
            error.response &&
            error.response.status === 401 &&
            !originalRequest._retry &&
            route !== Vue.prototype.$apiRouter.ssRefresh &&
            route !== Vue.prototype.$apiRouter.ssLogout
        ) {
            originalRequest._retry = true;

            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const response = await httpClient.post(Vue.prototype.$apiRouter.ssRefresh, {
                        refresh_token: localStorage.getItem('ss_refresh_token'),
                    });
                    localStorage.setItem('ss_access_token', response.data.data.access_token);
                    localStorage.setItem('ss_refresh_token', response.data.data.refresh_token);
                    originalRequest.headers.Authorization = `Bearer ${response.data.data.access_token}`;
                    onTokenRefreshed(response.data.data.access_token);
                    isRefreshing = false;
                    return httpClient(originalRequest);
                } catch (refreshError) {
                    store.commit('setError', refreshError.response.data.message || 'Refresh error');
                    localStorage.removeItem('ss_access_token');
                    isRefreshing = false;
                    return Promise.reject(refreshError);
                }
            } else {
                return new Promise((resolve) => {
                    subscribeTokenRefresh((token) => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        resolve(httpClient(originalRequest));
                    });
                });
            }
        } else if (error.response && error.response.status === 401 && route === Vue.prototype.$apiRouter.ssRefresh) {
            localStorage.removeItem('ss_access_token');
            localStorage.removeItem('ss_refresh_token');
            store.commit('ssClearProducts');
            store.commit('ssClearOrders');
            store.commit('ssClearShipper');

            const route = localStorage.getItem('ss_department_hash')
                ? `/self-serves/${localStorage.getItem('ss_department_hash')}`
                : '/self-serves';
            await router.push(route);
        } else {
            return Promise.reject(error);
        }
    }
);

export default { httpClient };
